export default __webpack_public_path__ + "static/media/photo--sm--72.177ce9e4.jpg";